import React, { useState } from 'react';
import { Phone, Mail, Menu, X, Star, Heart, Smile, Shield, Award, Users, Quote, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import bgImage from './assets/bg.jpg';
import aboutImage from './assets/about.jpg'
import OneImage from './assets/3.jpeg'
import TwoImage from './assets/2.jpeg'
import ThreeImage from './assets/4.jpeg'
import Logo from './assets/logo.png'

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    question: ''
  });
  const [open, setOpen] = useState(null);


  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent("New Question from Website");
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nQuestion:\n${formData.question}`
    );

    window.location.href = `mailto:xpress@xcdlab.com?subject=${subject}&body=${body}`;
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = 80; // Height of fixed header (h-20 = 5rem = 80px)
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth'
      });
      setIsMenuOpen(false); // Close mobile menu after clicking
    }
  };

  const terms = [
    {
      title: "Remake Policy",
      text: "Clients may inspect cases prior to acceptance, but must notify XCDL within 5 business days if not satisfied.",
    },
    {
      title: "Payment Terms",
      text: "Monthly statements provided via mail, email, or portal. Full payment required within 30 days, or a 3% late penalty applies. All major credit cards accepted",
    },
    {
      title: "No Warranty",
      text: "No warranty applies to repairs that exceed the remake policy.",
    },
  ];

  const services = [
    { icon: <Smile className="w-6 h-6" />, title: 'Preventive Dentistry', description: 'Checkups & Cleanings' },
    { icon: <Heart className="w-6 h-6" />, title: 'Cosmetic Dentistry', description: 'Porcelain Veneers' },
    { icon: <Shield className="w-6 h-6" />, title: 'Restorative Dentistry', description: 'Crowns & Bridges' },
    { icon: <Star className="w-6 h-6" />, title: 'Teeth Whitening', description: 'Advanced Technology' },
    { icon: <Award className="w-6 h-6" />, title: 'Orthodontics', description: 'Invisalign & Braces' },
    { icon: <Users className="w-6 h-6" />, title: 'Dental Implants', description: 'Permanent Solutions' }
  ];

  const officeHours = [
    { day: 'MONDAY', hours: '8:00 am - 5:00 pm' },
    { day: 'TUESDAY', hours: '8:00 am - 5:00 pm' },
    { day: 'WEDNESDAY', hours: '8:00 am - 5:00 pm' },
    { day: 'THURSDAY', hours: '8:00 am - 5:00 pm' },
    { day: 'FRIDAY', hours: '8:00 am - 5:00 pm' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-black/80 backdrop-blur-sm fixed top-0 w-full z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <div className="w-[10rem] h-10 flex items-center justify-center">
                <img src={Logo} />
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#about" onClick={(e) => scrollToSection(e, 'about')} className="text-white/80 hover:text-white transition">About Us</a>
              <a href="https://lms.3shape.com/3ui/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition">Client Portal</a>
              <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')} className="text-white/80 hover:text-white transition">Contact</a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-white/10"
            >
              {isMenuOpen ? <X className="w-6 h-6 text-white" /> : <Menu className="w-6 h-6 text-white" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="md:hidden py-4 border-t border-white/20">
              <div className="flex flex-col space-y-4">
                <a href="#about" onClick={(e) => scrollToSection(e, 'about')} className="text-white/80 hover:text-white transition">About Us</a>
                <a href="https://lms.3shape.com/3ui/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition">Client Portal</a>
                <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')} className="text-white/80 hover:text-white transition">Contact</a>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${bgImage})`
            }}
          />

          {/* Gradient overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/70"></div>
        </div>

        {/* Content */}
        <div className="flex flex-col justify-end relative z-10 container mx-auto px-4 text-left pt-20 min-h-[calc(100vh-5rem)]">
          <div className="w-full flex flex-col items-center pb-20 animate-fadeInUp">
            
            <h1 className="text-5xl flex flex-row md:text-6xl lg:text-6xl font-bold text-white">
            <Quote className="w-5 h-5 rotate-180 mr-2"/> <span className="block hero-header">Restoring smiles with precision, comfort, </span>
            </h1>
            <h1 className="text-5xl flex flex-row md:text-6xl lg:text-6xl font-bold text-white">
              <span className="block hero-header">and craftsmanship made just for you.</span>
              <Quote className="w-5 h-5 rotate-270 mr-2"/> 
            </h1>
          </div>
        </div>

        {/* Bottom gradient fade to next section */}
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 1s ease-out 0.3s both;
        }

        .animate-fadeInUp {
          animation: fadeInUp 1s ease-out 0.6s both;
        }

        @media (max-width: 768px) {
          .hero-header {
            line-height: 32px;
          }
        }
      `}</style>

      {/* Experience Section */}
      <section id="about" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="relative">
              <img src={aboutImage} className='h-[40rem] rounded-2xl w-full object-cover'/>
            </div>
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl info-style font-[700] text-[#fcba02]">
                About Us
              </h2>
              <p className="text-[1.3rem] text-gray-600 info-style font-[500]">
              At Xpress Custom Dental Lab, our technicians bring over 20 years of experience to every case. We are a service-driven, customer-focused organization dedicated to delivering personalized solutions that meet the unique needs of each client.<br/><br/>
              We take pride in our craftsmanship and attention to detail, coordinating job-specific requirements to ensure exceptional results. Whether your needs are simple or complex, our passion lies in providing high-quality work—on demand.<br/><br/>
              Our team supports you throughout the process, offering guidance in case design, preparation protocols, technology selection, and treatment planning. Our goal is to help you achieve optimal aesthetics, contour, and fit.<br/><br/>
              As a forward-thinking lab, we stay current with the latest technologies and techniques to deliver removable restorations that are functional, comfortable, and visually appealing—helping you and your patients create the perfect smile.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefit Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
            {[
              {
                id: 1,
                text: `All clients get LabStar-powered access to manage, track, and pay for their case.`,
                image: OneImage,
                color: "black"
              },
              {
                id: 2,
                text: "We offer FREE case pickup and delivery across the DMV area.",
                image: TwoImage,
                color: "#fcba02"
              },
              {
                id: 3,
                text: "Walk-ins and rush cases are always welcome.",
                image: ThreeImage,
                color: "black"
              },
            ].map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-center justify-between text-center bg-white p-4 rounded-2xl shadow-sm hover:shadow-md transition h-full"
              >
                <div className="relative mb-4">
                  <div className="w-28 h-28 md:w-36 md:h-36 mx-auto bg-gradient-to-br from-teal-400 to-teal-600 rounded-full overflow-hidden border-4 border-teal-500 flex items-center justify-center group-hover:scale-110 transition"
                  style={{
                    border: `0.5rem solid ${item.color}`,
                  }}
                  >
                    <img
                      src={item.image}
                      alt="Offer 1"
                      className="object-cover w-full h-full rounded-full"
                    />
                  </div>
                </div>
                <h3 className="font-semibold text-gray-800 text-base mb-2">#. {item.id}</h3>
                <p className="text-sm md:text-lg text-gray-500 w-full px-4">{item.text}</p>
              </div>
            ))}
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center justify-between gap-6">
            <div className="flex flex-col text-left items-center justify-center group cursor-pointer">
              <div className="relative mb-4">
                <div className="w-24 h-24 md:w-32 md:h-32 mx-auto bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center group-hover:scale-110 transition">
                  <Users className="w-12 h-12 md:w-16 md:h-16 text-white" />
                </div>
              </div>
              <h3 className="font-semibold text-gray-800 text-sm md:text-base">#. 1</h3>
              <p className="text-xs md:text-xl w-[50%] text-gray-500">For all new clients , first case is free of charge.</p>
            </div>
            <div className="flex flex-col text-left items-center justify-center group cursor-pointer">
              <div className="relative mb-4">
                <div className="w-24 h-24 md:w-32 md:h-32 mx-auto bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center group-hover:scale-110 transition">
                  <Users className="w-12 h-12 md:w-16 md:h-16 text-white" />
                </div>
              </div>
              <h3 className="font-semibold text-gray-800 text-sm md:text-base">#. 2</h3>
              <p className="text-xs md:text-xl w-[50%] text-gray-500">For all clients Case pickup and delivery are free.</p>
            </div>
            <div className="flex flex-col text-left items-center justify-center group cursor-pointer">
              <div className="relative mb-4">
                <div className="w-24 h-24 md:w-32 md:h-32 mx-auto bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center group-hover:scale-110 transition">
                  <Users className="w-12 h-12 md:w-16 md:h-16 text-white" />
                </div>
              </div>
              <h3 className="font-semibold text-gray-800 text-sm md:text-base">#. 3</h3>
              <p className="text-xs md:text-xl w-[50%] text-gray-500">All clients will gain personalized LabStar powered access to track, pay, and manage cases.</p>
            </div>
          </div> */}
        </div>
      </section>

      {/* Perfect Smile Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 gap-12 items-center">
            <div className="bg-white rounded-2xl shadow-md divide-y">
              {terms.map((term, i) => (
                <div key={i} className="p-6">
                  <button
                    onClick={() => setOpen(open === i ? null : i)}
                    className="flex justify-between w-full text-left font-semibold text-gray-700"
                  >
                    {term.title}
                    <span>{open === i ? "−" : "+"}</span>
                  </button>
                  {open === i && <p className="mt-2 text-gray-600 text-sm">{term.text}</p>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

 {/* Contact Section */}
      <section id="services" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Contact Us
              </h2>
              <p className="text-lg text-gray-600">
              Submit your request today and let us help you create the perfect smile.
              </p>
            </div>

            <div className="text-center">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-[#fcba02] text-white px-12 py-4 rounded-xl font-semibold hover:bg-[#e5a802] transition transform hover:scale-105"
              >
                Send message
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer id='contact' className="bg-gray-900 text-gray-300 py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-[10rem] h-10 flex items-center justify-center">
                  <img src={Logo} />
                </div>
              </div>
              <div className="space-y-2">
                {officeHours.map((schedule, index) => (
                  <div key={index} className="flex justify-between">
                    <span className="font-semibold">{schedule.day}</span>
                    <span className="opacity-90">{schedule.hours}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Location</h4>
              <ul className="space-y-2 text-sm">
                <li className='hover:text-[#fcba02] transition cursor-pointer'>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=7600+Hanover+Pkwy+Ste+202+Greenbelt+MD+20770"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    7600 Hanover Pkwy Ste 202,
                    Greenbelt MD 20770
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Contact Us</h4>
              <ul className="space-y-2 text-sm">
                <li className='hover:text-[#fcba02] transition cursor-pointer flex flex-row gap-2'>
                  <Phone className="w-5 h-5" />
                  <a href='tel:301-477-4959'>301-477-4959</a>
                </li>
                <li className='hover:text-[#fcba02] transition cursor-pointer flex flex-row gap-2'>
                  <Mail className="w-5 h-5" />
                  <a href='mailto:xpress@xcdlab.com'>xpress@xcdlab.com</a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">FOLLOW US</h4>
              <div className="flex space-x-3">
                <a target='blank' href="https://www.instagram.com/xcdlab?igsh=eXljZm8ycjdmenZq" className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center hover:bg-[#fcba02] transition">
                  <Instagram className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm">
            <p>© 2020 XPRESS CUSOTM DENTAL LAB INC.</p>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center rounded-t-2xl">
              <h2 className="text-3xl font-bold text-gray-800">Contact Us</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition"
              >
                <X className="w-6 h-6 text-gray-600" />
              </button>
            </div>

            <div className="p-6">
              <form onSubmit={(e) => { handleSubmit(e); setIsModalOpen(false); }}>
                <div className="grid md:grid-cols-3 gap-6 mb-6">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fcba02]"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fcba02]"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fcba02]"
                      required
                    />
                  </div>
                </div>
                <div className="mb-6">
                  <textarea
                    name="question"
                    placeholder="Request"
                    rows="4"
                    value={formData.question}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fcba02]"
                    required
                  ></textarea>
                </div>
                <div className="flex gap-4 justify-end">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="bg-gray-200 text-gray-800 px-8 py-3 rounded-full font-semibold hover:bg-gray-300 transition"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-[#fcba02] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#e5a802] transition"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;